/**
 * Max coordinate value (both positive and negative)
 */
export const hiRange = 9007199254740991;
